import { z } from 'zod';
var AnalyticsGroupSchema = z.function()
    .args(z.string(), z.record(z.unknown()))
    .returns(z.record(z.unknown()).promise());
var AnalyticsIdentifySchema = z.function()
    .args(z.string(), z.record(z.unknown()))
    .returns(z.record(z.unknown()).promise());
var AnalyticsTrackSchema = z.function()
    .args(z.string(), z.record(z.unknown()).optional(), z.record(z.unknown()).optional(), z.function().optional());
// TODO: Track return type and fix conform to void type
// .returns(z.void());
var AnalyticsPageSchema = z.function().returns(z.unknown().promise());
export var AnalyticsSchema = z.object({
    group: AnalyticsGroupSchema,
    identify: AnalyticsIdentifySchema,
    track: AnalyticsTrackSchema,
    page: AnalyticsPageSchema
});
